import React, { useState, useEffect } from "react";
import { Table, Image, Input, Button, Popconfirm, Card, message } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import api from "../../api";
import { useNavigate } from "react-router-dom";

const CarTypeListPage = () => {
  const [carTypes, setCarTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    search: "",
    production_year: "",
    brand: "",
    car_type: "",
  });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  useEffect(() => {
    fetchCarTypes();
  }, [filters, pagination.current, pagination.pageSize]);

  const fetchCarTypes = async () => {
    setLoading(true);
    try {
      const response = await api.get("/panel/car-type", { 
        params: {
          ...filters,
          page: pagination.current,
          per_page: pagination.pageSize,
        }
      });
      setCarTypes(response.data.data);
      setPagination(prev => ({
        ...prev,
        total: response.data.meta.total,
      }));
    } catch (error) {
      console.error("خطا در دریافت تیپ خودروها:", error);
    }
    setLoading(false);
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    // Reset to first page when filters change
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/panel/car-type/${id}`);
      message.success("تیپ مورد نظر با موفقیت حذف شد");
      fetchCarTypes();
    } catch (error) {
      console.error("خطا در حذف تیپ خودرو:", error);
    }
  };

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  const columns = [
    {
      title: "شناسه",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "نام تیپ خودرو",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "تصویر",
      dataIndex: "image",
      key: "image",
      render: (image) => <Image width={80} src={image} alt="car type image" />,
    },
    {
      title: "تاریخ ایجاد",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "عملیات",
      key: "actions",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Button
            type="primary"
            onClick={() => navigate(`/car_type/edit/${record.id}`)}
            icon={<EditOutlined />}
          />
          <Popconfirm
            title="آیا از حذف این تیپ خودرو مطمئن هستید؟"
            onConfirm={() => handleDelete(record.id)}
            okText="بله"
            cancelText="خیر"
          >
            <Button danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <Card>
      <h1 className="text-2xl font-bold mb-7">لیست تیپ خودروها</h1>

      <div
        className="flex justify-between"
        style={{ display: "flex", gap: "10px", marginBottom: "16px" }}
      >
        <Input
          placeholder="جستجو..."
          allowClear
          value={filters.search}
          onChange={(e) => handleFilterChange("search", e.target.value)}
          style={{ width: "200px" }}
        />
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate("/car_type/add")}
        >
          افزودن تیپ خودرو
        </Button>
      </div>
      <Table
        dataSource={carTypes}
        columns={columns}
        rowKey="id"
        loading={loading}
        pagination={{
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: ['10', '25', '50', '100'],
          showTotal: (total, range) => `${range[0]}-${range[1]} از ${total} مورد`,
        }}
        onChange={handleTableChange}
      />
    </Card>
  );
};

export default CarTypeListPage;